export default "__VITE_ASSET__BdZUBCYy__"